import React from "react";

const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.5"
      height="11.875"
      viewBox="0 0 12.5 11.875"
    >
      <path
        d="M6.24956 0L4.33925 3.89925L0 4.52847L3.14341 7.60159L2.392 11.875L6.24956 9.8185L10.1079 11.875L9.36206 7.60159L12.5 4.52847L8.18478 3.89925L6.24956 0Z"
        fillRule="nonzero"
        transform="matrix(1 0 0 1 0 0)"
        fill="rgb(248, 178, 78)"
      />
    </svg>
  );
};

export default StarIcon;
